import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { BankAccountsQuery } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import BanksInfiniteSelectField from '@/components/_common/BanksInfiniteSelectField';

function BankAccountExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<BankAccountsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col lg={6} span={24} md={12}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl.formatMessage({
            id: 'bankAccounts.form.description',
          })}
        />
      </Col>

      <Col lg={8} span={24} md={12}>
        <BanksInfiniteSelectField
          placeholder={'Banco'}
          value={queryParams?.bankId}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, bankId: value }))
          }
          allowClear
        />
      </Col>

      <Col lg={5} span={24} md={12}>
        <Input
          value={queryParams?.bankBranch}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, bankBranch: value }))
          }
          placeholder={intl.formatMessage({
            id: 'bankAccounts.form.bankBranch',
          })}
        />
      </Col>

      <Col lg={5} span={24} md={12}>
        <Input
          value={queryParams?.number}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, number: value }))
          }
          placeholder={intl.formatMessage({
            id: 'bankAccounts.form.number',
          })}
        />
      </Col>

      <Col lg={3} span={24} md={6}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col lg={3} span={24} md={6}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default BankAccountExtraFilters;
